<template>
  <div>
    <div id="page-panel">
      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
           <!-- <el-dropdown size="small" type="default" class="">
             <el-button type="primary" size="small">
               <i class="el-icon-download"></i>
             </el-button>
             <el-dropdown-menu slot="dropdown">
               <el-dropdown-item :disabled="true"><i class="mdi mdi-file-pdf"/> PDF</el-dropdown-item>
               <el-dropdown-item @click.native="downloadSalesReport('csv')"><i class="mdi mdi-file-excel"/> CSV</el-dropdown-item>
             </el-dropdown-menu>
           </el-dropdown> -->
           <el-button type="primary" @click="handleShowFilter" size="small"><i class="mdi mdi-filter"></i> </el-button>
  			</div>
      </div>
      <el-form  label-position="top" v-show="showFilters">
        <el-form-item :label="$t('reports.filters.PredefinedPeriod')">
          <el-select v-model="filters.period" popper-class="predefined_popper" value-key="code" @select="handlePeriodSelect">
            <el-option
              v-for="item in predefinedPeriod"
              :key="item.code"
              :label="$t('reports.filters.predefined.'+item.code)"
              :value="item">
              <span >{{ $t('reports.filters.predefined.'+item.code) }}</span><br>
              <span class="fs-14 secondary-text">{{ item.description }}</span>
            </el-option>
          </el-select>
          <el-date-picker
            class="mt-20"
            v-if="filters.period!=null && filters.period.code=='CUSTOM' && filters.period.range"
            v-model="filters.dateRange"
            type="daterange"
            range-separator="à"
            :start-placeholder="$t('common.startDate')"
            :end-placeholder="$t('common.endDate')">
          </el-date-picker>
          <el-date-picker
            class="mt-20"
            v-if="filters.period!=null && filters.period.code=='CUSTOM' && !filters.period.range"
            v-model="filters.date"
            type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('clients.rep')">
          <el-select v-model="filters.selectedReps" value-key="id" multiple :disabled="isStrictFilteredByRep === true && isCurrentUserRep === true && !isCurrentUserAdmin">
            <el-option
              v-for="item in salesRep"
              :key="item.id"
              :label="item.firstName + ' ' + item.lastName"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CMSProduct.product_type')">
          <el-select v-model="filters.selectedProductTypes" value-key="id" multiple >
            <el-option
              v-for="item in productTypesList"
              :key="item.id"
              :label="item.name[lang]"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CMSProduct.product_specific_type')">
          <el-select v-model="filters.selectedProductSubTypes" value-key="id" multiple >
            <el-option
              v-for="item in productSubTypesList"
              :key="item.id"
              :label="item.productType.name[lang] + ' - ' + item.name[lang]"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.products')">
          <SelectProduct @selected="handleProductSelect" :selected="false" :summary="true"></SelectProduct>
          <el-table
          v-if="filters.selectedProducts.length > 0"
            :data="filters.selectedProducts"
            stripe
            border
            style="width: 100%">
            <el-table-column
              prop="sku"
              :label="$t('produtcs.sku')">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('produtcs.name')">
            </el-table-column>
            <el-table-column width="80">
              <template slot-scope="scope">
                <el-button size="mini" circle type="danger" @click="removeProduct(scope.$index)"><i class="mdi mdi-delete fs-15"></i></el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>
        <el-form-item :label="$t('common.clients')">
          <SelectCustomer @selected="handleCustomerSelect" :selected="false"></SelectCustomer>
          <el-table
          stripe
          border
          v-if="filters.selectedCustomers.length > 0"
            :data="filters.selectedCustomers"
            style="width: 100%">
            <el-table-column
              prop="name"
              :label="$t('clients.name')">
            </el-table-column>
            <el-table-column >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.in"
                  @change=" v=> handleExceptionChange(scope.$index, v)"
                  active-text="Inclus"
                  inactive-text="Exclus">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column width="80">
              <template slot-scope="scope">
                <el-button size="mini" circle type="danger" @click="removeCustomer(scope.$index)"><i class="mdi mdi-delete fs-15"></i></el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>
        <el-form-item :label="$t('clients.filterDialog.territories')">
          <el-select v-model="filters.selectedTerritories" value-key="id" multiple >
            <el-option
              v-for="item in territories"
              :key="item.id"
              :label="item.code"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('clients.class')">
          <el-select v-model="filters.selectedCustomerClasses" value-key="id" multiple >
            <el-option
              v-for="item in customerClasses"
              :key="item.id"
              :label="item.code"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.provider')">
          <SelectCustomer @selected="handleProviderSelect" :selected="false"></SelectCustomer>
          <el-table
            v-if="filters.selectedProviders.length > 0"
            stripe
            border
            :data="filters.selectedProviders"
            style="width: 100%">
            <el-table-column
              prop="name"
              :label="$t('clients.name')">
            </el-table-column>
            <el-table-column width="80">
              <template slot-scope="scope">
                <el-button size="mini" circle type="danger" @click="removeProvider(scope.$index)"><i class="mdi mdi-delete fs-15"></i></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-button type="primary" @click="applyFilters">{{$t('common.apply')}}</el-button>
      </el-form>
      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>

      </p>
      <div id="printMe">
        <div class="">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.totalValueTooltip')">
                <div>
                  <InfoStatsCard :text="$t('reports.totalValue')" v-bind:total="formatAmount((parseFloat(stats.total_value) || 0) + (parseFloat(stats.total_agency_fee) || 0) - (parseFloat(stats.discount_amount) || 0))" v-bind:sign="''" v-bind:icon="'mdi-cash-check'" v-bind:status="'success'"></InfoStatsCard>
                </div>
              </el-tooltip>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.valuestooltip')">
                <div>
                  <InfoStatsCard  :text="$t('reports.values')" v-bind:total="formatAmount(stats.total_value)" v-bind:sign="''" v-bind:icon="'mdi-cash'"  v-bind:status="'success'" ></InfoStatsCard>
                </div>
              </el-tooltip>
              
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.agencyFeesTooltip')">
                <div>
                  <InfoStatsCard  :text="$t('products.agencyFees')" v-bind:total="formatAmount(stats.total_agency_fee)" v-bind:sign="''" v-bind:icon="'mdi-currency-usd'"  v-bind:status="'success'" ></InfoStatsCard>
                </div>
              </el-tooltip>
              
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.rebateTooltip')">
                <div>
                  <InfoStatsCard  :text="$t('sales_orders.rebate')" v-bind:total="formatAmount(stats.discount_amount)" v-bind:sign="''" v-bind:icon="'mdi-currency-usd'"  v-bind:status="'success'" ></InfoStatsCard>
                </div>
              </el-tooltip>
              
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.averageBottlePriceTooltip')">
                <div>
                  <InfoStatsCard
                    text="Prix moyen / bouteille (incluant frais d'agence)"
                    v-bind:total="formatAmount(averageBottlePriceIncludingAgencyFee)"
                    v-bind:sign="''"
                    v-bind:icon="'mdi-bottle-wine-outline'"
                    v-bind:status="'success'" />
                </div>
              </el-tooltip>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.averageAgencyFeePerBottleTooltip')">
                <div>
                  <InfoStatsCard
                    text="Frais d'agence moyen / bouteille"
                    v-bind:total="formatAmount(averageAgencyFeePerBottle)"
                    v-bind:sign="''"
                    v-bind:icon="'mdi-calculator-variant-outline'"
                    v-bind:status="'success'" />
                </div>
              </el-tooltip>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.qtyBottleTooltip')">
                <div>
                  <InfoStatsCard  :text="$t('common.QtyBt')" v-bind:total="formatNumber(stats.qty)" v-bind:sign="''" v-bind:icon="'mdi mdi-numeric'"  v-bind:status="'success'" ></InfoStatsCard>
                </div>
              </el-tooltip>
            
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-tooltip effect="dark" placement="top" :content="$t('reports.statistics.qty9LTooltip')">
                <div>
                  <InfoStatsCard  :text="$t('common.Qty9L')" v-bind:total="formatNumber(stats.qty_standardize)" v-bind:sign="''" v-bind:icon="'mdi mdi-numeric-9-box-outline'"  v-bind:status="'success'" ></InfoStatsCard>
                </div>
              </el-tooltip>
              
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row class="mt-20">
            <salesGraphics :filters="prepareBuildRequest" :title="$t('reports.evolution12MonthsTitle')" :showQuantity="true"> </salesGraphics>
          </el-row>
          <el-divider></el-divider>
          <el-row style="text-align:center">
            <el-radio-group v-model="showDataBy" size="small">
              <el-radio-button label="VALUE">{{$t('common.value')}}</el-radio-button>
              <el-radio-button label="AGENCYFEES">{{$t('products.agencyFees')}}</el-radio-button>
              <el-radio-button label="REBATE">{{$t('sales_orders.rebate')}}</el-radio-button>
              <el-radio-button label="QUANTITY">{{$t('common.quantity')}}</el-radio-button>
            </el-radio-group>
          </el-row>
          <el-row :gutter="5">
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByRepChart @change="handleRepChange" :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1" class="mb-50"></SalesByRepChart>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByProductTypeChart @change="handleProductTypeChange" :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByProductTypeChart>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByProductSpecificTypeChart @change="handleProductSubTypeChange" :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByProductSpecificTypeChart>
              </el-col>
          </el-row>
          <el-row :gutter="5">
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByTerritoriesChart @change="handleTerritoryChange" :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByTerritoriesChart>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByProvidersChart @change="handleProviderChange" :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByProvidersChart>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByPriceRangeChart :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByPriceRangeChart>
              </el-col>
          </el-row>
          <el-row :gutter="5">
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByCustomerClassChart @change="handleCustomerClassChange" :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByCustomerClassChart>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByRebateType :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByRebateType>
              </el-col> 
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <SalesByFeeType :showTable="true" :filters="prepareBuildRequest" :type="showDataBy" :max="-1"></SalesByFeeType>
              </el-col>
          </el-row>
        </div>
      </div>
    <WatingDialog :visible="loading" :content="$t('common.workInProgressContent2')"></WatingDialog>
</div>
<!-- </el-row> -->
</div>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import moment from 'moment'
import dayjs from 'dayjs'
// import { extendMoment } from 'moment-range';
// const moment = extendMoment(Moment);
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';
import * as echarts from 'echarts';
import Promise from "bluebird";
import WatingDialog from '@/components/waiting-dialog'
import customerUtil from '@/utils/customer-util'
import SelectCustomer from '@/components/customer/select-customer'
import SelectProduct from '@/components/product/select-product'
import InfoStatsCard from '@/components/Info-stat-card'
import salesGraphics from '@/components/sales-graphic'
import SalesByRepChart from '@/components/reports/sales-by-rep'
import SalesByProductTypeChart from '@/components/reports/sales-by-product-type'
import SalesByProductSpecificTypeChart from '@/components/reports/sales-by-product-specific-type'
import SalesByTerritoriesChart from '@/components/reports/sales-by-territory'
import SalesByProvidersChart from '@/components/reports/sales-by-provider'
import SalesByPriceRangeChart from '@/components/reports/sales-by-price-range'
import SalesByCustomerClassChart from '@/components/reports/sales-by-customer-class'
import SalesByRebateType from '@/components/reports/sales-by-rebate-type'
import SalesByFeeType from '@/components/reports/sales-by-fee-type'
import CMSApi from '@/services/API/cmsAPI'
import portausUtils from '@/utils/portaus-utils';

export default {
  name : "WineSales-report",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      showFilters: false,
      showDetails : false,
      chart: null,
      showDataBy: 'VALUE',
      productTypesList: [],
      productSubTypesList: [],
      exceptionsOptions: [
        {
          value: true,
          label: 'inclus',
        },
        {
          value: true,
          label: 'exclus',
        }
      ],
      // chartByProductType: null,
      // chartByProductSubType: null,
      stats : {total_value : 0, total_agency_fee:0, qty:0, qty_standardize:0,discount_amount:0},
      salesStatisticByDate : {value : [], agency_fee : [], sales : [], discount : []},
      output : null,
      data : [],
      loading:true,
      statusCode : [],
      filters : {
        inventoryId: null,
        range : 'MONTH',
        startDate : null,
        endDate : null,
        statuses : [],
        customerId : null,
        providerId: null,
        groupBy : 'CUSTOMER',
        customer_classes : [],
        selectedProducts: [],
        repId: [],
        productId: [],
        date: null,
        dateRange: null,
        period:{ code: 'MONTH'} ,
        selectedReps: [],
        selectedProviders: [],
        selectedCustomers: [],
        selectedProductSubTypes: [],
        selectedTerritories: [],
        productTypes: [],
        selectedCustomerClasses : [],
      },
      
      customerName : null,
      reportFilterVisible : false,
      pageWidth : null,
      pageHeight : null,
      pagination: {
        page: 1,
        size: 20,
        sizes: [10, 15, 20, 30, 50, 100],
        layout: 'total, ->, prev, pager, next, sizes',
        small: false
      },
    };
  },
  components : {
    reportFilter,
    WatingDialog,
    SelectProduct,
    SelectCustomer,
    InfoStatsCard,
    SalesByRepChart,
    salesGraphics,
    SalesByProductTypeChart,
    SalesByProductSpecificTypeChart,
    SalesByTerritoriesChart,
    SalesByProvidersChart,
    SalesByPriceRangeChart,
    SalesByCustomerClassChart,
    SalesByRebateType,
    SalesByFeeType,
  },
  computed : {
    pricesRangeList () {
      _.get(this.getReportCustomization, 'priceRange');
    },
    prepareBuildRequest () {
      var utc = require('dayjs/plugin/utc')
      dayjs.extend(utc)
      let filters = {};
      if(this.filters.startDate!=null){
        filters.startDate = dayjs(this.filters.startDate).utc().format();
      }
      if(this.filters.endDate!=null){
        filters.endDate = dayjs(this.filters.endDate).utc().format();
      }
     
      if (!_.isEmpty(this.filters.selectedProducts)) {
        filters.productId = _.map(this.filters.selectedProducts, p => (p.id));
      }

      if (!_.isEmpty(this.filters.selectedProviders)) {
        filters.providerId = _.map(this.filters.selectedProviders, p => (p.id));
      }

      if (!_.isEmpty(this.filters.selectedReps)) {
        filters.repId = _.map(this.filters.selectedReps, rep => (rep.id));
      }

      if (!_.isEmpty(this.filters.selectedCustomers)) {
        filters.customerId = _.map(_.filter(this.filters.selectedCustomers, c => c.in === true), customer => (customer.id));
      }

      if (!_.isEmpty(this.filters.selectedCustomers)) {
        filters.customerIdExceptions = _.map(_.filter(this.filters.selectedCustomers, c => c.in === false), customer => (customer.id));
      }

      filters.detailed = this.showDetails;
      filters.inventoryId = this.filters.inventoryId;

      if (!_.isEmpty(this.filters.selectedProductTypes)) {
        filters.productTypeId = _.map(this.filters.selectedProductTypes, p => (p.id));
      }

      if (!_.isEmpty(this.filters.selectedCustomerClasses)) {
        filters.customerClassId = _.map(this.filters.selectedCustomerClasses, p => (p.id));
      }

      if (!_.isEmpty(this.filters.selectedProductSubTypes)) {
        filters.productSpecificTypeId = _.map(this.filters.selectedProductSubTypes, p => (p.id));
      }

      if (!_.isEmpty(this.filters.selectedTerritories)) {
        filters.territoryId = _.map(this.filters.selectedTerritories, p => (p.id));
      }

      return filters;
    },
    selectedCustomer(){
      if(this.filters.customerId!=null && this.filters.customerId!=undefined){
        return {id:this.filters.customerId}
      }else{
        return null;
      }
    },
    selectedProvider(){
      if(this.filters.providerId!=null && this.filters.providerId!=undefined){
        return {id:this.filters.providerId}
      }else{
        return null;
      }
    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    reportCode(){
      return this.$route.params.code;
    },
    usableData(){
      return this.data.data;
    },
    currentMonthDates(){

      if(this.filters.startDate!=null){
        return new Array(moment(this.filters.startDate).daysInMonth()).fill(null).map((x, i) => moment(this.filters.startDate).startOf('month').add(i, this.interval));
      }else{
        return new Array(moment().daysInMonth()).fill(null).map((x, i) => moment().startOf('month').add(i, 'days'));
      }


    },
    interval(){
      let startDate = moment(this.filters.startDate);
      let endDate = moment(this.filters.endDate);
      let interval = 'months';
      const diff = endDate.diff(startDate, 'days');
      if (diff <= 30) {
        interval = 'days'
      } else if (diff > 30 && diff <= 90) {
        interval = 'weeks'
      } else {
        interval = 'months'
      }
      return interval;
    },
    dateRange(){
      let data = [];
      if(this.filters.range=='MONTH' || this.filters.range=='LAST_MONTH'){
        _.forEach(this.currentMonthDates, d=>{
          data.push(d.format('YYYY-MM-DD'));
        })
      } else if(this.filters.range=='FISCAL_YEAR' || this.filters.range=='LAST_FISCAL_YEAR'){
        let date = moment(this.filters.startDate)

        while(moment(this.filters.endDate).isAfter(date)){
          data.push(date.format('YYYY-MM'))
          date = date.add(1,'months');
        }

      } else {
        let startDate = moment(this.filters.startDate);
        let endDate = moment(this.filters.endDate);

        while(moment(this.filters.endDate).isAfter(startDate)){
          data.push(startDate.format('YYYY-MM-DD'));
          startDate = startDate.add(1,this.interval);
        }
      }
      return data;
    },
    axis(){
      const data = [];
      if(this.filters.range=='MONTH' || this.filters.range=='LAST_MONTH'){
        _.forEach(this.dateRange, d=>{
         
          data.push(moment(d).format('DD'));
        })
      }else {
        if (this.interval === 'months') {
          _.forEach(this.dateRange, d=>{
            data.push(moment(d).format('YYYY-MM'));
          })
        } else {
          _.forEach(this.dateRange, d=>{
            data.push(moment(d).format('YYYY-MM-DD'));
          })
        }

      }

      return data;
    },
    total() {
			return this.usableData != null ? this.usableData.length : 0;
		},
    listInPage(){
      if (this.usableData == null) return [];
      let from = (this.currentPage - 1) * this.itemPerPage
      let to = from + (this.itemPerPage*1)
      return this.usableData.slice(from, to)
    },
    currentPage: {
			get() {
				return this.pagination.page
			},
			set(val) {
				this.pagination.page = val
			}
		},
		itemPerPage() {
			return this.pagination.size
		},
    salesRep(){
      return this.filterUserWithRoleRep;
    },
    lang(){
      return this.$i18n.locale
    },
    averageBottlePriceIncludingAgencyFee () {
      const qty = parseFloat(this.stats.qty) || 0;
      if (qty <= 0) return 0;

      const totalValue = parseFloat(this.stats.total_value) || 0;
      const totalAgencyFee = parseFloat(this.stats.total_agency_fee) || 0;
      const totalDiscount = parseFloat(this.stats.discount_amount) || 0;

      return (totalValue + totalAgencyFee - totalDiscount) / qty;
    },
    averageAgencyFeePerBottle () {
      const qty = parseFloat(this.stats.qty) || 0;
      if (qty <= 0) return 0;

      const totalAgencyFee = parseFloat(this.stats.total_agency_fee) || 0;
      const totalDiscount = parseFloat(this.stats.discount_amount) || 0;

      return (totalAgencyFee - totalDiscount) / qty;
    },
    ...mapState('inventory',['inventories']),
    ...mapGetters('users',['filterUserWithRoleRep', 'getUserById']),
    ...mapGetters('inventory',['getWinePrivateImportInventories']),
    ...mapState('controlData',['customerClasses', 'territories']),
    ...mapGetters(['getReportCustomization', 'isStrictFilteredByRep', 'getCurrentUserId', 'isCurrentUserRep', 'isCurrentUserAdmin'])

  },
  methods : {
    formatAmount(amount, currency = 'CAD') {
      // console.log('amount : ', amount);
          return portausUtils.formatAmount(amount, this.$i18n.locale, currency);
      },
      formatNumber(amount) {
          return portausUtils.formatNumber(amount, this.$i18n.locale);
      },
    handleExceptionChange(index, v) {
      // console.log({v, index });
      // console.log(this.filters.selectedCustomers);
      this.filters.selectedCustomers[index].in = v;
    },
    handleRepChange (rep) {
      this.filters.selectedReps.splice(0);
      this.filters.selectedReps.push(rep);
      this.applyFilters();
    },
    handleProductTypeChange (productType) {
      this.filters.selectedProductTypes.splice(0);
      this.filters.selectedProductTypes.push(productType);
    },
    handleProductSubTypeChange (productSubType) {
      this.filters.selectedProductSubTypes.splice(0);
      this.filters.selectedProductSubTypes.push(productSubType);
    },
    handleTerritoryChange (territory) {
      this.filters.selectedTerritories.splice(0);
      this.filters.selectedTerritories.push(territory);
    },
    handleProviderChange (provider) {
      this.filters.selectedProviders.splice(0);
      this.filters.selectedProviders.push(provider);
    },
    handlePriceRangeChange (priceRange) {
      this.filters.selectedPriceRanges.splice(0);
      this.filters.selectedPriceRanges.push(priceRange);
    },
    handleCustomerClassChange (customerClass) {
      console.log(customerClass);
      this.filters.selectedCustomerClasses.splice(0);
      this.filters.selectedCustomerClasses.push(customerClass);
    },
    showDetail () {
      this.showDetails = true;
      this.fetchData();
    },
    handleProviderSelect (provider) {
      this.filters.selectedProviders.push(provider);
    },
    handleCustomerSelect (customer) {
      const c = {
        id: customer.id,
        name: customer.usualName || customer.name,
        in: true
      }
      this.filters.selectedCustomers.push(c);
    },
    removeProduct(index) {
      this.filters.selectedProducts.splice(index,1);
    },
    removeProvider (index) {
      this.filters.selectedProviders.splice(index,1);
    },
    removeCustomer (index) {
      this.filters.selectedCustomers.splice(index,1);
    },
    handleShowFilter (){
      this.showFilters = !this.showFilters;
    },
    handlePeriodSelect (period) {
      if(period!=null && period.code!='CUSTOM'){
        this.filters.dateRange = null;
      }
    },
    handleProductSelect (product) {
      this.filters.selectedProducts.push(product)
    },
    getCustomerName(name, usualName) {
      return customerUtil.customerName(name, usualName);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },openInvoice(invoiceId){
      var index='/invoices/'+invoiceId;
			this.$router.push(index);
    },openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
			this.$router.push(index);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    downloadSalesReport(type='csv'){
      this.loading = true;
      let filename = 'SALES_REPORT_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');
      filename+="."+type;
      let params = this.prepareBuildRequest;
      params.format=type;
      return salesAPI.downloadSalesReport(this.reportCode, filename, params)
        .then(() => {
          this.loading = false;
        }).catch(err=> {
          this.loading = false;

        })
    },
    applyFilters () {
      this.filters.range = _.get(this, 'filters.period.code');
      if (_.get(this, 'filters.period.code') === 'MONTH') {
        this.filters.startDate = this.month.startDate;
        this.filters.endDate = this.month.endDate;
        this.filters.dateRange = [this.month.startDate, this.month.endDate];
      } else if (_.get(this, 'filters.period.code') === 'LAST_MONTH') {
        this.filters.startDate = this.lastMonth.startDate;
        this.filters.endDate = this.lastMonth.endDate;
        this.filters.dateRange = [this.lastMonth.startDate, this.lastMonth.endDate];
      } else if (_.get(this, 'filters.period.code') === 'FISCAL_YEAR') {
        this.filters.startDate = this.fiscalYearDate.startDate;
        this.filters.endDate = this.fiscalYearDate.endDate;
        this.filters.dateRange = [this.fiscalYearDate.startDate, this.fiscalYearDate.endDate];
      } else if (_.get(this, 'filters.period.code') === 'LAST_FISCAL_YEAR') {
        this.filters.startDate = this.lastFiscalYearDate.startDate;
        this.filters.endDate = this.lastFiscalYearDate.endDate;
        this.filters.dateRange = [this.lastFiscalYearDate.startDate, this.lastFiscalYearDate.endDate];
      } else {
        //CUSTOM
        this.filters.startDate = this.filters.dateRange[0];
        this.filters.endDate = this.filters.dateRange[1];
        this.filters.dateRange = this.filters.dateRange;
      }
      this.handleShowFilter();
      this.fetchData();
    },
    // handleFilter(filters){
    //   let inventories = [];
    //   _.forEach(filters.inventories, m=>{
    //     inventories.push(m.id);
    //   })
    //   localStorage.sales_inventories = JSON.stringify(inventories);
    //   localStorage.sales_range=filters.period.code;
    //   localStorage.sales_startDate = filters.dateRange[0];
    //   localStorage.sales_endDate = filters.dateRange[1];
    //   localStorage.sales_customerId = filters.customer!=null ? filters.customer.id : undefined;
    //   localStorage.sales_providerId = filters.provider!=null ? filters.provider.id : undefined;
    //   // let reps = [];
    //   // _.forEach(filters.reps, m=>{
    //   //   reps.push(m.id);
    //   // })
    //   // localStorage.sales_reps = JSON.stringify(reps);

    //   localStorage.sales_product = JSON.stringify(filters.product);

    //   let customer_classes = [];
    //   _.forEach(filters.customer_classes, m=>{
    //     customer_classes.push(m.id);
    //   })
    //   localStorage.sales_customer_classes = JSON.stringify(customer_classes);


    //   if(filters.customer!=null){
    //     localStorage.sales_customerName = filters.customer.name;
    //   }


    //   this.setFilters();
    //   this.fetchData();
    // },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    getRealPeriodNumber(falseNumber){
      let number = falseNumber;
      if(falseNumber>12){
        number-=12;
      }
      return number;
    },
    showPeriodName(periodNumber){
      if(this.filters.groupBy=='MONTH'){
        return moment().month(this.getRealPeriodNumber(periodNumber)).format('MMM');
      }else{
        let realPeriodNumber= this.getRealPeriodNumber(periodNumber);
        let startMonth = moment().month(((realPeriodNumber+1)*3)-3).format('MMM');
        let endMonth = moment().month(((realPeriodNumber+1)*3)-1).format('MMM');
        return startMonth + '-' + endMonth
      }

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    
    fetchData(){
      this.loading = true;
      this.resetChartValues();
      this.stats.qty=0;
      this.stats.total_value=0;
      this.stats.total_agency_fee=0;
      this.stats.qty_standardize = 0;
      this.stats.discount_amount = 0;
      let filters = this.prepareBuildRequest;

      return salesAPI.getSalesEvolution(filters)
        .then(data=>{
          this.stats.total_value = _.get(_.head(data), 'value');
          this.stats.total_agency_fee =  _.get(_.head(data), 'agencyfees');
          this.stats.discount_amount = _.get(_.head(data), 'discount');
          this.stats.qty = _.get(_.head(data), 'qty');
          this.stats.qty_standardize = _.get(_.head(data), 'qty9l');
          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      if (this.isStrictFilteredByRep === true && this.isCurrentUserRep === true && this.isCurrentUserAdmin === false) {
        this.filters.selectedReps.push({id : this.getCurrentUserId });
      }
      this.filters.startDate = this.month.startDate;
      this.filters.endDate = this.month.endDate;
      this.filters.dateRange = [this.month.startDate, this.month.endDate];
      this.filters.inventoryId = _.get(_.head(this.getWinePrivateImportInventories), 'id');
    },
    fetchProductTypes(){
      return CMSApi.fetchProductTypes()
        .then((productTypes) => {
          this.productTypesList = productTypes;
          return productTypes;
        })
    },
    fetchProductSubTypes(){
      return CMSApi.fetchProductSpecificTypes()
        .then((productSubTypes) => {
          this.productSubTypesList = productSubTypes;
          return productSubTypes;
        })
    },
    resetChartValues(){
      _.forEach(this.dateRange, (d, index)=>{
        this.salesStatisticByDate.value[index]=0;
        this.salesStatisticByDate.agency_fee[index]=0;
        this.salesStatisticByDate.sales[index]=0;
        this.salesStatisticByDate.discount[index]=0;
      })
    },
    ...mapActions('inventory',['fetchInventories']),
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('controlData',['fetchCustomerClasses', 'fetchTerritories'])
  },
  mounted(){
    
    this.setPageWidth();
  },
  beforeDestroy(){
    this.data = [];
  },
  created(){
    this.loading = true;
    return Promise.all([
      this.fetchAdminUsers(),
      this.fetchProductTypes(),
      this.fetchProductSubTypes(),
      this.fetchInventories(),
      this.fetchTerritories(),
      this.fetchCustomerClasses()])
        .then(()=> this.setFilters())
        .then(() => this.fetchData())
        .catch((err) => {
          console.log(err);
        })
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
